/**
 * @generated SignedSource<<b64c6707c78e0859acfb0e4a6aedf5c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type insuranceServiceRequestLogQuery$variables = {
  insuranceid: string;
  queryEnd: any;
  queryStart: any;
  requeststatus: number;
};
export type insuranceServiceRequestLogQuery$data = {
  readonly insurance_request_log_connection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly insuranceid: string;
        readonly recipientid: string | null | undefined;
        readonly requeststatus: number;
        readonly requesttype: number;
      };
    }>;
  };
};
export type insuranceServiceRequestLogQuery = {
  response: insuranceServiceRequestLogQuery$data;
  variables: insuranceServiceRequestLogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insuranceid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryEnd"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryStart"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requeststatus"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_gte",
                "variableName": "queryStart"
              },
              {
                "kind": "Variable",
                "name": "_lte",
                "variableName": "queryEnd"
              }
            ],
            "kind": "ObjectValue",
            "name": "created_at"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "insuranceid"
              }
            ],
            "kind": "ObjectValue",
            "name": "insuranceid"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_neq",
                "variableName": "requeststatus"
              }
            ],
            "kind": "ObjectValue",
            "name": "requeststatus"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_logConnection",
    "kind": "LinkedField",
    "name": "insurance_request_log_connection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "insurance_request_logEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "insurance_request_log",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requeststatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requesttype",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recipientid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "insuranceid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "insuranceServiceRequestLogQuery",
    "selections": (v4/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "insuranceServiceRequestLogQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "1b5dc1215263bfe6b951b3c32ccebc9b",
    "id": null,
    "metadata": {},
    "name": "insuranceServiceRequestLogQuery",
    "operationKind": "query",
    "text": "query insuranceServiceRequestLogQuery(\n  $insuranceid: String!\n  $requeststatus: Int!\n  $queryStart: timestamptz!\n  $queryEnd: timestamptz!\n) {\n  insurance_request_log_connection(where: {insuranceid: {_eq: $insuranceid}, created_at: {_gte: $queryStart, _lte: $queryEnd}, requeststatus: {_neq: $requeststatus}}) {\n    edges {\n      node {\n        requeststatus\n        requesttype\n        recipientid\n        insuranceid\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "591b28d1eee88b1759b631ef268eafe4";

export default node;
